import { GatsbySeo } from 'gatsby-plugin-next-seo';
import React from 'react'
import Agency from '../components/Agency';
import Experts from '../components/Experts';
import  Layout  from '../components/Layout';
import Main from '../components/Main';
import Services from '../components/Services';
import Trust from '../components/Trust';
import Values from '../components/Values';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'
import { graphql } from 'gatsby';

interface homeProps {
    data : any
}
//Home page template English/French 
const Home: React.FC<homeProps> = ({data}) => {
    // These data are fetched from Prismic, by using GraphQL.
    const main = data.prismicHomeMain.data 
    const dev = data.prismicHomeDevelopment.data
    const experts = data.prismicHomeExperts.data
    const trust = data.prismicTrust.data
    const agencies = data.prismicAgencies.data
    const values = data.prismicHomeValues.data
    const seo = data.prismicSeo.data
    const image = data.prismicHomeImage.data
    return (
      <Layout>
        <GatsbySeo
      title={`${seo.title.text} | ${seo.text.text}`}
      description={seo.description.text}
    />
        <Main image={image} main={main} />
        <Services dev={dev} />
        <Experts  experts={experts}/>
        <Trust trust={trust}/>
        <Agency agencies={agencies}/>
        <Values values={values}/>
        
      </Layout>
    );
}
export const query = graphql`
  query homeQuery($lang: String) {
    prismicHomeMain(lang: { eq: $lang }) {
        lang
        alternate_languages {
          id
        }
        data {
          btn
          
          paragraph {
            text
          }
          
        }
      }
      prismicHomeImage {
        data {
          image {
            gatsbyImageData
          }
        }
      }
      prismicTrust(lang: { eq: $lang }) {
        data {
          btn
          title {
            text
          }
          paragraph {
            text
          }
        }
      }
      prismicHomeDevelopment(lang: { eq: $lang }) {
        data {
          btn
          grid {
            grid_item {
              document {
                ... on PrismicGridItem {
                  id
                  data {
                    img {
                      gatsbyImageData
                    }
                    title {
                      text
                    }
                    paragraph {
                      text
                    }
                  }
                }
              }
            }
          }
          paragraph {
            text
          }
          title {
            text
          }
        }
      }
      prismicSeo(lang: { eq: $lang }) {
    data {
      description {
        text
      }
      text {
        text
      }
      title {
        text
      }
    }
  }
      prismicHomeExperts(lang: { eq: $lang }) {
        data {
          title {
            text
          }
          grid {
            grid_item {
              document {
                ... on PrismicGridItem {
                  id
                  data {
                    title {
                      text
                    }
                    paragraph {
                      text
                    }
                    img {
                      gatsbyImageData
                    }
                  }
                }
              }
            }
          }
          paragraphs {
            paragraph {
              text
            }
          }
        }
      }
      prismicAgencies(lang: { eq: $lang }) {
        data {
          title {
            text
          }
          grid {
            grid_item {
              document {
                ... on PrismicGridItem {
                  id
                  data {
                    title {
                      text
                    }
                    paragraph {
                      text
                    }
                    img {
                      gatsbyImageData
                    }
                  }
                }
              }
            }
          }
        }
      }
      prismicHomeValues(lang: { eq: $lang }) {
        data {
          values {
            value
          }
          btn
          title {
            text
          }
          grid {
            grid_item {
              document {
                ... on PrismicGridItem {
                  id
                  data {
                    title {
                      text
                    }
                    paragraph {
                      text
                    }
                    img {
                      gatsbyImageData
                    }
                  }
                }
              }
            }
          }
        }
      }
  }
`

export default withPrismicPreview(Home)